<!-- Compact -->
<compact-project-layout [projectid]="projectid" [project]="project"></compact-project-layout>